import {
  LOGIN_END_SUCCESS,
  LOGIN_END_FAILED,
  LOGIN_START,
  RESET_AUTH_ERROR,
  USER_ACTIVATED,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED
} from "../constants";

export const loginStart = () => {
  return { type: LOGIN_START };
};

export const loginEnd = () => {
  return { type: LOGIN_END_SUCCESS };
};

export const loginEndFailed = error => {
  return { type: LOGIN_END_FAILED, payload: error };
};

export const resetAuthError = () => {
  return { type: RESET_AUTH_ERROR };
};

export const userMessage = payload => {
  return { type: USER_ACTIVATED, payload };
};

export const resetPassword = () => {
  return { type: RESET_PASSWORD };
};

export const resetPasswordSFailed = payload => {
  return { type: RESET_PASSWORD_FAILED, payload };
};
